import './App.css';
import Gallery from './components/Gallery';


function App() {
  return (
    <div className="App">
      <center>
      <Gallery/>
      </center>
    </div>
  );
}

export default App;
